// extracted by mini-css-extract-plugin
module.exports = {"container":"-y2_m","link":"J9jL5","term":"X9DGN"};